export default "<span class=\"created-by\"></span>\n"